export const LoaderPageAnime = {
  from: {
    top: 0,
  },
  to: {
    top: "-100vh",
    transition: {
      delay: 7,
      type: "spring",
      stiffness: 30,
    },
  },
};
export const ServerMsgAnime = {
  from: {
    opacity: 0,
  },
  to: {
    opacity: 1,
    transition: {
      delay: 1,
    },
  },
};
export const htmlMsgAnime = {
  from: {
    opacity: 0,
  },
  to: {
    opacity: 1,
    transition: {
      delay: 2,
    },
  },
};
export const cssMsgAnime = {
  from: {
    opacity: 0,
  },
  to: {
    opacity: 1,
    transition: {
      delay: 3,
    },
  },
};
export const jsMsgAnime = {
  from: {
    opacity: 0,
  },
  to: {
    opacity: 1,
    transition: {
      delay: 4,
    },
  },
};
export const reactMsgAnime = {
  from: {
    opacity: 0,
  },
  to: {
    opacity: 1,
    transition: {
      delay: 5,
    },
  },
};
export const finalMsgAnime = {
  from: {
    opacity: 0,
  },
  to: {
    opacity: 1,
    transition: {
      delay: 6,
    },
  },
};
export const htmlLogoAnime = {
  from: {
    top: "-100vh",
  },
  to: {
    position: "fixed",
    left: "50%",
    top: " 50%",
    transform: "translate(-50%,-50%)",
    opacity: [1, 1, 1, 1, 1, 0.8, 0.6, 0.4, 0.2, 0.1, 0],
    transition: {
      delay: 1,
      type: "spring",
      stiffness: 30,
    },
  },
};
export const cssLogoAnime = {
  from: {
    left: "120vw",
  },
  to: {
    position: "fixed",
    left: "50%",
    top: " 50%",
    transform: "translate(-50%,-50%)",
    opacity: [1, 1, 1, 1, 1, 0.8, 0.6, 0.4, 0.2, 0.1, 0],
    transition: {
      delay: 2,
      type: "spring",
      stiffness: 30,
    },
  },
};
export const jsLogoAnime = {
  from: {
    top: "120vh",
  },
  to: {
    position: "fixed",
    left: "50%",
    top: " 50%",
    transform: "translate(-50%,-50%)",
    opacity: [1, 1, 1, 1, 1, 0.8, 0.6, 0.4, 0.2, 0.1, 0],
    transition: {
      delay: 3,
      type: "spring",
      stiffness: 30,
    },
  },
};
export const reactLogoAnime = {
  from: {
    left: "-100vw",
  },
  to: {
    position: "fixed",
    left: "50%",
    top: " 50%",
    transform: "translate(-50%,-50%)",
    opacity: [1, 1, 1, 1, 1, 0.8, 0.6, 0.4, 0.2, 0.1, 0],
    transition: {
      delay: 4,
      type: "spring",
      stiffness: 30,
    },
  },
};
